// src/mappers/array.ts
var arrayMapper = (mapper) => ({
  transformFrom: (input) => {
    if (!Array.isArray(input))
      return input;
    if (input.length == 0)
      return input;
    return input.map((item) => mapper.transformFrom(item));
  },
  transformTo: (input) => {
    if (!Array.isArray(input))
      return input;
    if (input.length == 0)
      return input;
    return input.map((item) => mapper.transformTo(item));
  }
});

// src/mappers/date.ts
var toDate = (input) => {
  if (input instanceof Date)
    return input;
  if (typeof input === "string" || typeof input === "number") {
    let date = new Date(input);
    if (!isNaN(date.getTime()))
      return date;
  }
  return input;
};
var dateMapper = () => ({
  transformFrom: (input) => toDate(input),
  transformTo: (input) => toDate(input)
});

// src/mappers/object.ts
var objectMapper = (properties) => {
  let fromTransformers = new Map(
    Object.entries(properties).map(([toKey, value]) => [
      value.fromKey,
      { toKey, mapper: value.mapper }
    ])
  );
  let toTransformers = new Map(
    Object.entries(properties).map(([toKey, value]) => [
      toKey,
      { fromKey: value.fromKey, mapper: value.mapper }
    ])
  );
  return {
    transformFrom: (input) => {
      if (typeof input != "object" || input == null)
        return input;
      let output = {};
      let keys = new Set(Object.keys(input));
      for (let [fromKey, { toKey, mapper }] of fromTransformers) {
        if (!keys.has(fromKey))
          continue;
        output[toKey] = mapper.transformFrom(input[fromKey]);
        keys.delete(fromKey);
      }
      for (let key of keys) {
        output[key] = input[key];
      }
      return output;
    },
    transformTo: (input) => {
      if (typeof input != "object" || input == null)
        return input;
      let output = {};
      let keys = new Set(Object.keys(input));
      for (let [toKey, { fromKey, mapper }] of toTransformers) {
        if (!keys.has(toKey))
          continue;
        output[fromKey] = mapper.transformTo(input[toKey]);
        keys.delete(toKey);
      }
      for (let key of keys) {
        output[key] = input[key];
      }
      return output;
    }
  };
};
var objectField = (fromKey, mapper) => ({
  fromKey,
  mapper
});

// src/mappers/passthrough.ts
var passthroughMapper = () => ({
  transformFrom: (input) => input,
  transformTo: (input) => input
});

// src/mappers/union.ts
var getType = (input) => {
  if (Array.isArray(input))
    return "array";
  if (input instanceof Date)
    return "date";
  if (typeof input == "object" && input != null)
    return "object";
  return typeof input;
};
var unionMapper = (options) => {
  let mappersByType = new Map(options.map((o) => [o.type, o.mapper]));
  return {
    transformFrom: (input) => {
      let mapper = mappersByType.get(getType(input));
      if (!mapper)
        return input;
      return mapper.transformFrom(input);
    },
    transformTo: (input) => {
      let mapper = mappersByType.get(getType(input));
      if (!mapper)
        return input;
      return mapper.transformTo(input);
    }
  };
};
var unionOption = (type, mapper) => ({
  type,
  mapper
});

// src/index.ts
var mtMap = {
  object: objectMapper,
  objectField,
  union: unionMapper,
  unionOption,
  array: arrayMapper,
  date: dateMapper,
  passthrough: passthroughMapper
};
export {
  mtMap
};
//# sourceMappingURL=index.js.map